export default "__VITE_ASSET__Cd7dQtQL__"